import {connect} from 'react-redux';
import {CuvetteSeal as Component} from './CuvetteSeal';
import {
  pushInteractions,
  createCuvetteSeal,
  setHeldObject,
  setHeld,
  setCuvetteSealsInScene,
  setCuvetteSealHeld,
  setCuvetteSealControlVisibility,
  hideAllControls,
  cuvetteItemDrop
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("cuvetteSeals") &&
     state.notebook.protocolSection.scene.apparatus.cuvetteSeals.some(
       box => box.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.cuvetteSeals[ownProps.id-1].type,
      controlsVisible: state.notebook.protocolSection.scene.apparatus.cuvetteSeals[ownProps.id - 1].controlsVisible,
      lastDrop: state.notebook.protocolSection.scene.lastDrop,
      heldObject: state.notebook.protocolSection.scene.heldObject,
      inScene: state.notebook.protocolSection.scene.apparatus.cuvetteSeals[ownProps.id-1].inScene,
      interactionProps: {
        cuvettes: state.notebook.protocolSection.scene.apparatus.cuvettes,
      },
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createCuvetteSeal: (data)=>{
      dispatch(createCuvetteSeal(data))
    },
    setCuvetteSealControlVisibility: (data) => {
      dispatch(setCuvetteSealControlVisibility(data))
    },
    setCuvetteSealsInScene: (data) => {
      dispatch(setCuvetteSealsInScene(data))
    },
    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },
    setHeld: (data) => {
      dispatch(setHeld(data))
    },
    setCuvetteSealHeld: (data) => {
      dispatch(setCuvetteSealHeld(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    onDropCuvetteSeal: (data)=>{
      dispatch(cuvetteItemDrop(data))
    },
    pushInteractions: (data) => {
      dispatch(pushInteractions(data))
    },
  };
}

export const CuvetteSeal = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
